import './App.css';
import React, { useState } from "react";
import AnnouncementBar from './Components/AnnouncementBar';
import ContactSection from './Components/ContactSection';
import Footer from './Components/Footer';

function App() {
  const [activeCourse, setActiveCourse] = useState("ge");
  return (
    <div className="App">

      {/* ===== Announcement Bar ===== */}
      <AnnouncementBar />

      {/* ===== Navigation Bar ===== */}
      <nav className="navbar">

        {/* Left: Navigation Links */}
        <ul className="nav-links">
          <li><a href="#courses">Courses</a></li>
          <li><a href="#about">About Us</a></li>
          <li><a href="#studyinAU">Study in Australia</a></li>
          {/* <li> <a href="#lmsLogin">LMS Login</a></li> */}
        </ul>

        {/* Center: Logo */}
        <div className="nav-center">
          <img src="/OEG Logo.png" alt="OEG Logo" className="nav-logo" />
        </div>

        {/* Right: Action Buttons */}
        <div className="nav-actions">
          <a className="btn-filled" href="https://drive.google.com/file/d/1jKSjK6bIYnmXY23j3Df515V88BsYSzd0/view?usp=sharing" target='blank'>Enrol Now</a>
          <a className="btn-outline" href="#contact">Enquire Now</a>

        </div>


      </nav>
      {/* ===== Hero Section ===== */}
      <section className="hero-section" id='top-hero'>
        <div className="hero-bg-shapes">
          <div className="hero-shape hero-shape-1"></div>
          <div className="hero-shape hero-shape-2"></div>
          <div className="hero-shape hero-shape-3"></div>
        </div>
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">🎓 CRICOS Provider: 04381E</div>
            <h1 className="hero-title">
              Master English.<br/>
              <span className="gradient-text">Shape Your Future.</span>
            </h1>
            <p className="hero-description">
              Premier English language education in the heart of Melbourne. From General English to Academic Excellence, we prepare you for success in Australia and beyond.
            </p>
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number">1000+</div>
                <div className="stat-label">Students Enrolled</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">95%</div>
                <div className="stat-label">Success Rate</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">Countries</div>
              </div>
            </div>
            <div className="hero-buttons">
              <a href="https://drive.google.com/file/d/1jKSjK6bIYnmXY23j3Df515V88BsYSzd0/view?usp=sharing" className="hero-btn primary">Start Your Journey</a>
              <a href="#courses" className="hero-btn secondary">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="5 3 19 12 5 21 5 3"></polygon>
                </svg>
                Explore Courses
              </a>
            </div>
          </div>
          {/* Right Side Single Image */}
          <div className="hero-image-box">
            <img src="/assets/hero-main.png" alt="Students studying" />
          </div>
        </div>
      </section>

      {/* ===== Features Section ===== */}
      <section className="features-section">
        <div className="features-container">
          <div className="section-header">
            {/* <span className="section-badge">Why Choose OEG</span> */}
            <h2 className="section-title">Why Choose Ozzi Education Group?</h2>
            <p className="section-subtitle">Comprehensive programs designed for your success</p>
          </div>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon blue">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
                  <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
                </svg>
              </div>
              <h3>CRICOS Accredited</h3>
              <p>Fully accredited provider (04381E) offering quality assurance and internationally recognized qualifications.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon yellow">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <h3>Expert Instructors</h3>
              <p>Learn from qualified teachers with years of experience in English language education and TESOL certification.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon green">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </div>
              <h3>Modern Facilities</h3>
              <p>Interactive learning tools with comfortable study spaces in the campus. Students are given extensive learning resources, online materials, and support tools included in your course.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon purple">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
                  <path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>
                </svg>
              </div>
              <h3>Pathway Programs</h3>
              <p>Direct pathways to universities and vocational colleges across Australia upon course completion.</p>
            </div>
            
          </div>
        </div>
      </section>
      {/* ===== CTA Section ===== */}
      <section className="cta-section">
        <div className="cta-shapes">
          <div className="cta-shape cta-shape-1"></div>
          <div className="cta-shape cta-shape-2"></div>
        </div>
        <div className="cta-container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Start Your English Learning Journey?</h2>
            <p className="cta-description">Join hundreds of international students who chose OEG for their English education in Melbourne</p>
            <div className="cta-buttons">
              <a href="https://drive.google.com/file/d/1jKSjK6bIYnmXY23j3Df515V88BsYSzd0/view?usp=sharing" target='blank' className="cta-btn primary">Enrol Now</a>
              <a href="#contact" className="cta-btn secondary">Ask a Question</a>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Courses Section ===== */}
      <section className="courses-section" id="courses">
        <div className="courses-container">
          <div className="section-header">
            <h2 className="section-title">Find Your Perfect English Course</h2>
            <p className="section-subtitle">Choose between General English or Academic English - we'll guide you every step of the way</p>
          </div>

          {/* Course Selection Tabs */}
          <div className="course-tabs">
            <button 
              className={`tab-btn ${activeCourse === "ge" ? "active" : ""}`} 
              onClick={() => setActiveCourse("ge")}
            >
              <div className="tab-icon">📚</div>
              <div className="tab-content">
                <strong>General English</strong>
                <span>Everyday Communication</span>
              </div>
            </button>

            <button 
              className={`tab-btn ${activeCourse === "eap" ? "active" : ""}`} 
              onClick={() => setActiveCourse("eap")}
            >
              <div className="tab-icon">🎓</div>
              <div className="tab-content">
                <strong>Academic English (EAP)</strong>
                <span>University Preparation</span>
              </div>
            </button>
          </div>


          {/* General English Course Content */}
          <div className={`course-content ${activeCourse === "ge" ? "active" : ""}`} id="ge-content">
            <div className="course-overview">
              <div className="overview-badge">⭐ Most Popular Choice</div>
              <h3>General English (GE) - ELICOS</h3>
              <p className="overview-description">
                Perfect for students who want to improve their everyday English for travel, work, or social situations. 
                Start from absolute beginner or enhance your existing skills across 6 comprehensive levels.
              </p>
            </div>

            <div className="course-grid-layout">
              {/* Left Column */}
              <div className="course-left">
                <div className="info-card">
                  <div className="info-card-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <h4>Course Duration</h4>
                  </div>
                  <div className="info-card-body">
                    <p><strong>Total:</strong> 72 Weeks</p>
                    <p>• 60 Weeks of Classes</p>
                    <p>• 12 Weeks of Scheduled Breaks</p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-card-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                    </svg>
                    <h4>Accreditation</h4>
                  </div>
                  <div className="info-card-body">
                    <p><strong>CRICOS Code:</strong> 118510J</p>
                    <p><strong>Provider:</strong> Ozzi Education Group</p>
                    <p><strong>Provider Code:</strong> 04381E</p>
                  </div>
                </div>

                <div className="info-card highlighted">
                  <div className="info-card-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    </svg>
                    <h4>Entry Requirements</h4>
                  </div>
                  <div className="info-card-body">
                    <p><strong>Age:</strong> 18 years and above</p>
                    <p><strong>English Level:</strong> No specific requirements - assessed by Oxford Placement Test and interview</p>
                    <p><strong>Education:</strong> Year 10 or equivalent (typically expected)</p>
                    <p className="note">💡 Students with little or no English are welcome!</p>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="course-right">
                <div className="levels-showcase">
                  <h4>Your 6-Level Journey</h4>
                  <p className="levels-intro">We'll assess your current level and place you in the right class. Progress through each level at your own pace!</p>
                  
                  <div className="level-cards">
                    <div className="level-detail-card">
                      <div className="level-badge">Level 1</div>
                      <h5>Starter</h5>
                      <p className="level-for">For: Students with no or very little English</p>
                      <p className="level-cefr">CEFR: Beginner</p>
                    </div>

                    <div className="level-detail-card">
                      <div className="level-badge">Level 2</div>
                      <h5>Elementary</h5>
                      <p className="level-for">For: Basic English speakers</p>
                      <p className="level-cefr">CEFR: A1</p>
                    </div>

                    <div className="level-detail-card">
                      <div className="level-badge">Level 3</div>
                      <h5>Pre-Intermediate</h5>
                      <p className="level-for">For: Simple conversation ability</p>
                      <p className="level-cefr">CEFR: A2</p>
                    </div>

                    <div className="level-detail-card">
                      <div className="level-badge">Level 4</div>
                      <h5>Intermediate</h5>
                      <p className="level-for">For: Comfortable everyday English</p>
                      <p className="level-cefr">CEFR: B1</p>
                    </div>

                    <div className="level-detail-card">
                      <div className="level-badge">Level 5</div>
                      <h5>Upper Intermediate</h5>
                      <p className="level-for">For: Fluent in most situations</p>
                      <p className="level-cefr">CEFR: B1+</p>
                    </div>

                    <div className="level-detail-card">
                      <div className="level-badge">Level 6</div>
                      <h5>Advanced</h5>
                      <p className="level-for">For: Near-native proficiency</p>
                      <p className="level-cefr">CEFR: B2</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* EAP Course Content */}
          <div className={`course-content ${activeCourse === "eap" ? "active" : ""}`} id="eap-content">
            <div className="course-overview">
              <div className="overview-badge academic">🎓 University Pathway</div>
              <h3>English for Academic Purposes (EAP) - ELICOS</h3>
              <p className="overview-description">
                Specifically designed for students planning to study at Australian universities. Develop the academic English 
                skills you need for essays, presentations, research, and university-level discussions.
              </p>
            </div>

            <div className="course-grid-layout">
              {/* Left Column */}
              <div className="course-left">
                <div className="info-card academic">
                  <div className="info-card-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <polyline points="12 6 12 12 16 14"></polyline>
                    </svg>
                    <h4>Course Duration</h4>
                  </div>
                  <div className="info-card-body">
                    <p><strong>Total:</strong> 48 Weeks</p>
                    <p>• 40 Weeks of Classes</p>
                    <p>• 8 Weeks of Scheduled Breaks</p>
                  </div>
                </div>

                <div className="info-card academic">
                  <div className="info-card-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                    </svg>
                    <h4>Accreditation</h4>
                  </div>
                  <div className="info-card-body">
                    <p><strong>CRICOS Code:</strong> 118511H</p>
                    <p><strong>Provider:</strong> Ozzi Education Group</p>
                    <p><strong>Provider Code:</strong> 04381E</p>
                  </div>
                </div>

                <div className="info-card highlighted academic">
                  <div className="info-card-header">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    </svg>
                    <h4>Entry Requirements</h4>
                  </div>
                  <div className="info-card-body">
                    <p><strong>Age:</strong> 18 years and above</p>
                    <p><strong>English Level (Pathway Students):</strong> IELTS 5.0 or equivalent</p>
                    <p><strong>English Level (Standalone):</strong> No IELTS requirement</p>
                    <p><strong>Education:</strong> Year 10 or equivalent expected</p>
                    <p className="note">💡 Assessment via English Placement Test and interview</p>
                  </div>
                </div>
              </div>

              {/* Right Column */}
              <div className="course-right">
                <div className="levels-showcase">
                  <h4>Your 4-Level Academic Journey</h4>
                  <p className="levels-intro">Each level prepares you for increasingly complex academic tasks and university-level English.</p>
                  
                  <div className="level-cards">
                    <div className="level-detail-card academic">
                      <div className="level-badge academic">Level 1</div>
                      <h5>Pre-Intermediate</h5>
                      <p className="level-for">Entry: CEFR A2 → Exit: CEFR B1</p>
                      <p className="level-outcome">Develop essential academic skills and language for tertiary study</p>
                    </div>

                    <div className="level-detail-card academic">
                      <div className="level-badge academic">Level 2</div>
                      <h5>Intermediate</h5>
                      <p className="level-for">Entry: CEFR B1 → Exit: CEFR B1+</p>
                      <p className="level-outcome">Further develop academic English skills for tertiary education</p>
                    </div>

                    <div className="level-detail-card academic">
                      <div className="level-badge academic">Level 3</div>
                      <h5>Upper Intermediate</h5>
                      <p className="level-for">Entry: CEFR B1+ → Exit: CEFR B2</p>
                      <p className="level-outcome">Enhance comprehension and production of structured academic content</p>
                    </div>

                    <div className="level-detail-card academic">
                      <div className="level-badge academic">Level 4</div>
                      <h5>Advanced</h5>
                      <p className="level-for">Entry: CEFR B2 → Exit: CEFR C1</p>
                      <p className="level-outcome">Master essential skills for university-level English studies</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
          </div>

          {/* Course Comparison */}
          <div className="course-comparison">
            <h3>Still not sure which course is right for you?</h3>
            <p>Book a free consultation with our education advisors. We'll assess your current level, discuss your goals, and recommend the perfect pathway for your success in Australia.</p>
            <a href="#contact" className="comparison-btn">Get Free Consultation</a>
          </div>
        </div>
      </section>
      {/* ===== About Us Section ===== */}
      <section class="about-us-section cta-style" id="about">
        <div class="cta-shapes">
          <div class="cta-shape cta-shape-1"></div>
          <div class="cta-shape cta-shape-2"></div>
        </div>
        <div class="container">
          <div class="about-us-content">
            <div class="about-us-image">
              <img src="/assets/about-us-image.png" alt="About Us" />
            </div>
            <div class="about-us-text">
              <h2 class="cta-title">About Us</h2>
              <p class="cta-description">
                We are a dedicated team committed to providing high-quality education and guidance for students aspiring to study abroad. Our mission is to make your learning journey seamless and successful.
                With years of experience in educational consulting, we provide expert advice, personalized plans, and full support for students who want to study in Australia and other countries. Our team helps with course selection, application guidance, and visa processes.
              </p>
              <p class="cta-description">
                Our vision is to empower students with knowledge, confidence, and resources to achieve their academic goals abroad.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== Study in Australia Section ===== */}
      <section class="study-australia-section" id="studyinAU">
        <div class="container">
          <div class="section-header">
            {/* <span class="section-badge">Global Education</span> */}
            <h2 class="section-title">Study in Australia</h2>
            <p class="section-subtitle">
              Discover opportunities to study in Australia, a country known for its world-class education, vibrant culture, and diverse career prospects.
            </p>
          </div>

          <div class="study-australia-cards">
            <div class="study-card">
              <h3>Top Universities</h3>
              <p>Explore Australia’s leading universities offering a wide range of programs for international students.</p>
            </div>
            <div class="study-card">
              <h3>Student Life</h3>
              <p>Experience a vibrant student lifestyle with multicultural communities, events, and support services.</p>
            </div>
            <div class="study-card">
              <h3>Visa & Immigration</h3>
              <p>Get guidance on student visas, work permits, and staying compliant while studying abroad.</p>
            </div>
          </div>
        </div>
      </section>


      <ContactSection/>
      <Footer />

    </div>
  );
}

export default App;
